import { KeyDict } from "@/types"
import { TranscodingRegion } from "@/types/admin"
import { WowzaStat, WOWZA_THREAD_LIMIT } from "@/types/wowza"


export default class WowzaLoadBalancer {
  getServerUrlToStreamTo (transcodingregion: TranscodingRegion, wowzastats: KeyDict<WowzaStat>): string|undefined {
    const keys = Object.keys(transcodingregion.wrtcserver).sort()
    const keysWithStats = keys.filter(key => {
      return Object.keys(wowzastats).includes(key) && wowzastats[key].threadCount < WOWZA_THREAD_LIMIT
    })
    keysWithStats.sort((key1, key2) => {
      const count1 = wowzastats[key1].connectionCount
      const count2 = wowzastats[key2].connectionCount
      return count1 < count2 ? -1 : 1
    })
    const workableKeys = Object.values(keysWithStats).length > 0 ? keysWithStats : keys
    if (Object.values(workableKeys).length > 0)
      return transcodingregion.wrtcserver[workableKeys[0]].url
    return undefined
  }
}